// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AuditHour } from './auditHour.zod.ts';

export const AuditSummary = zod.object({
  "actors": zod.int(),
  "clamped": zod.boolean(),
  "event_families": zod.record(zod.string(), zod.int()),
  "failed_sign_ins": zod.int(),
  "hours": zod.array(AuditHour),
  "outcomes": zod.record(zod.string(), zod.int()),
  "source_ips": zod.int(),
  "total": zod.int(),
  "window_from": zod.iso.datetime({"offset":true}),
  "window_to": zod.iso.datetime({"offset":true})
});

export type AuditSummary = zod.input<typeof AuditSummary>;
export type AuditSummaryOutput = zod.output<typeof AuditSummary>;
